export const METRIC = "metric";
export const IMPERIAL = "imperial";

export const STONE_ABOVE_TABLE = "STONE_ABOVE_TABLE";
export const STONE_BELOW_TABLE = "STONE_BELOW_TABLE";

/* MISC ENUMERATORS */
export const AUTOMATION_PROJECT_TYPE_CHAMBER = "AUTOMATION_PROJECT_TYPE_CHAMBER";
export const AUTOMATION_PROJECT_TYPE_PIPE = "AUTOMATION_PROJECT_TYPE_PIPE";

export const GLOBAL_PROJECT_TYPE_CHAMBER = "CHAMBER";
export const GLOBAL_PROJECT_TYPE_PIPE = "PIPE";
export const GLOBAL_ENABLE_DEBUGING = "GLOBAL_ENABLE_DEBUGING";
export const GLOBAL_REFRESH_ADMIN_PROJECTS = "GLOBAL_REFRESH_ADMIN_PROJECTS";
export const GLOBAL_LOGIN_USER = "GLOBAL_LOGIN_USER";
export const GLOBAL_LOGOUT_USER = "GLOBAL_LOGOUT_USER";
export const GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT = "GLOBAL_DRAWING_SELECTOR_MODE_DEFAULT";
export const GLOBAL_DRAWING_SELECTOR_MODE_DIRECT = "GLOBAL_DRAWING_SELECTOR_MODE_DIRECT";
export const GLOBAL_DRAWING_MODE_ADD = "GLOBAL_DRAWING_MODE_ADD";
export const GLOBAL_DRAWING_MODE_REMOVE = "GLOBAL_DRAWING_MODE_REMOVE";
export const GLOBAL_DRAWING_MODE_INSERTA_TEE = "GLOBAL_DRAWING_MODE_INSERTA_TEE";
export const GLOBAL_DRAWING_MODE_INSPECTION_PORT = "GLOBAL_DRAWING_MODE_INSPECTION_PORT";
export const GLOBAL_DRAWING_MODE_INLET_MANIFOLD = "GLOBAL_DRAWING_MODE_INLET_MANIFOLD";
export const GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD = "GLOBAL_DRAWING_MODE_OUTLET_MANIFOLD";

export const GLOBAL_CHAMBER_PLAN_SCALE_IN = "GLOBAL_CHAMBER_PLAN_SCALE_IN";
export const GLOBAL_PIPE_PLAN_SCALE_IN = "GLOBAL_PIPE_PLAN_SCALE_IN";
export const GLOBAL_CHAMBER_PLAN_SCALE_MT = "GLOBAL_CHAMBER_PLAN_SCALE_MT";
export const GLOBAL_PIPE_PLAN_SCALE_MT = "GLOBAL_PIPE_PLAN_SCALE_MT";

export const VIEWPORT_SET_STAGE_NODE = "VIEWPORT_SET_STAGE_NODE";
export const VIEWPORT_SET_DIMENSIONS = "VIEWPORT_SET_DIMENSIONS";
export const VIEWPORT_ADD_PRESSED_KEY = "VIEWPORT_ADD_PRESSED_KEY";
export const VIEWPORT_DELETE_PRESSED_KEY = "VIEWPORT_DELETE_PRESSED_KEY";
export const VIEWPORT_SCALE = "VIEWPORT_SCALE";
export const VIEWPORT_SCALE_PIPES = "VIEWPORT_SCALE_PIPES";
export const VIEWPORT_POSITION = "VIEWPORT_POSITION";
export const VIEWPORT_POSITION_PIPES = "VIEWPORT_POSITION_PIPES";
export const VIEWPORT_SWITCH_PANNING = "VIEWPORT_SWITCH_PANNING";
export const VIEWPORT_RESET_POSITION_SCALE = "VIEWPORT_RESET_POSITION_SCALE";

export const DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED = "DRAWINGTOOLBAR_BACKGROUND_FILE_SELECTED";
export const DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE = "DRAWINGTOOLBAR_BACKGROUND_SHOW_HIDE";
export const DRAWINGTOOLBAR_BACKGROUND_LOADED = "DRAWINGTOOLBAR_BACKGROUND_LOADED";
export const DRAWINGTOOLBAR_BACKGROUND_EDIT = "DRAWINGTOOLBAR_BACKGROUND_EDIT";
export const DRAWINGTOOLBAR_MEASURETOOL_EDIT = "DRAWINGTOOLBAR_MEASURETOOL_EDIT";
export const DRAWINGTOOLBAR_MEASURETOOL_LOADED = "DRAWINGTOOLBAR_MEASURETOOL_LOADED";
export const DRAWINGTOOLBAR_SCALE_EDIT = "DRAWINGTOOLBAR_SCALE_EDIT";
export const DRAWINGTOOLBAR_SCALE_SHOW = "DRAWINGTOOLBAR_SCALE_SHOW";
export const DRAWINGTOOLBAR_MOUSECLICMEASURE = "DRAWINGTOOLBAR_MOUSECLICMEASURE";
export const DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE = "DRAWINGTOOLBAR_SCALE_UNIT_VALUE_CHANGE";
export const DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE = "DRAWINGTOOLBAR_CHAMBER_ROW_SPACING_VALUE_CHANGE";
export const DRAWINGTOOLBAR_SCALE_BROADCAST = "DRAWINGTOOLBAR_SCALE_BROADCAST";
export const DRAWINGTOOLBAR_CHANBERS_AUTOFILL = "DRAWINGTOOLBAR_CHANBERS_AUTOFILL";
export const DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY = "DRAWINGTOOLBAR_CHANBERS_AUTOEMTPY";
export const DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE = "DRAWINGTOOLBAR_SWITCH_SELECTOR_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE = "DRAWINGTOOLBAR_SWITCH_TO_ADD_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE = "DRAWINGTOOLBAR_SWITCH_TO_REMOVE_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE = "DRAWINGTOOLBAR_SWITCH_TO_INSERTA_TEE_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE = "DRAWINGTOOLBAR_SWITCH_TO_INSPECTION_PORT_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE = "DRAWINGTOOLBAR_SWITCH_TO_INLET_MANIFOLD_MODE";
export const DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE = "DRAWINGTOOLBAR_SWITCH_TO_OUTLET_MANIFOLD_MODE";
export const DRAWINGTOOLBAR_ENDCAPS_AUTOADD = "DRAWINGTOOLBAR_ENDCAPS_AUTOADD";
export const DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN = "DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN";

export const TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY = "TOPBAR_SWITCH_LOGOUT_DIALOG_VISIBILITY";

export const APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY = "APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY";
export const APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY = "APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY";
export const APPTOOLBAR_SELECT_CHAMBER_TYPE = "APPTOOLBAR_SELECT_CHAMBER_TYPE";
export const APPTOOLBAR_RESET_APP_STATE = "APPTOOLBAR_RESET_APP_STATE";
export const APPTOOLBAR_BASIC_RESET_APP_STATE = "APPTOOLBAR_BASIC_RESET_APP_STATE";
export const APPTOOLBAR_RESET_MULTIBED_STATE = "APPTOOLBAR_RESET_MULTIBED_STATE";
export const APPTOOLBAR_RESET_APP_STATE_PIPES = "APPTOOLBAR_RESET_APP_STATE_PIPES";
export const APPTOOLBAR_SET_CONSTRAINTS = "APPTOOLBAR_SET_CONSTRAINTS";
export const APPTOOLBAR_SELECT_PIPE_TYPE = "APPTOOLBAR_SELECT_PIPE_TYPE";
export const APPTOOLBAR_SELECT_PIPE_DIAMETER = "APPTOOLBAR_SELECT_PIPE_DIAMETER";

export const MULTIBED_RESET_APP_STATE = "MULTIBED_RESET_APP_STATE";
export const SHOW_INSERTA_TEE_WARNING = "SHOW_INSERTA_TEE_WARNING";
export const SHOW_INSERTA_TEE_WARNING_TYPE = "SHOW_INSERTA_TEE_WARNING_TYPE";
export const SHOW_INSERTA_TEE_VALUES = "SHOW_INSERTA_TEE_VALUES";
export const SHOW_FEED_CONNECTOR_VALUES = "SHOW_FEED_CONNECTOR_VALUES";
export const IMPERVIOUS_LINER = "IMPERVIOUS_LINER";
export const NUMBER_OF_FEED_CONNECTORS = "NUMBER_OF_FEED_CONNECTORS";
export const POSITION_OF_INSPECTION_PORT = "POSITION_OF_INSPECTION_PORT";

export const SUBMIT_DIALOG_SHOW = "SUBMIT_DIALOG_SHOW";
export const SUBMIT_DIALOG_ACCEPT = "SUBMIT_DIALOG_ACCEPT";
export const SUBMIT_DIALOG_REJECT = "SUBMIT_DIALOG_REJECT";
export const SUBMIT_DIALOG_CLOSE = "SUBMIT_DIALOG_CLOSE";

export const BACKGROUND_IMAGE_LOADED = "BACKGROUND_IMAGE_LOADED";
export const BACKGROUND_SHOW_HIDE = "BACKGROUND_SHOW_HIDE";
export const BACKGROUND_TRANSFORMED = "BACKGROUND_TRANSFORMED";
export const BACKGROUND_MOVED = "BACKGROUND_MOVED";
export const BACKGROUND_EDIT = "BACKGROUND_EDIT";
export const BACKGROUND_SCALE = "BACKGROUND_SCALE";

export const PDFDIALOG_PAGE_SELECT = "PDFDIALOG_PAGE_SELECT";
export const PDFDIALOG_PAGE_CHANGE = "PDFDIALOG_PAGE_CHANGE";
export const PDFDIALOG_CLOSE = "PDFDIALOG_CLOSE";
export const PDFDIALOG_NUM_PAGES_CHANGE = "PDFDIALOG_NUM_PAGES_CHANGE";

export const GENERATE_PDF_REPORT = "GENERATE_PDF_REPORT";

export const SCALELINE_START_MEASURING = "SCALELINE_START_MEASURING";
export const SCALELINE_END_MEASURING = "SCALELINE_END_MEASURING";
export const SCALELINE_SET_PIXELS = "SCALELINE_SET_PIXELS";
export const SCALELINE_RESET = "SCALELINE_RESET";


export const MEASURETOOL_START_MEASURING = "MEASURETOOL_START_MEASURING";
export const MEASURETOOL_END_MEASURING = "MEASURETOOL_END_MEASURING";
export const MEASURETOOL_SET_PIXELS = "MEASURETOOL_SET_PIXELS";
export const MEASURETOOL_RESET = "MEASURETOOL_RESET";

export const STONE_BED_POINTS_MOVED = "STONE_BED_POINTS_MOVED";
export const STONE_BED_COMPUTE = "STONE_BED_COMPUTE";
export const STONE_BED_SET_SEPARATION_DISTANCE = "STONE_BED_SET_SEPARATION_DISTANCE";
export const STONE_BED_SWITCH_VISIBILITY = "STONE_BED_SWITCH_VISIBILITY";

export const CHAMBER_SET_CENTRALICED_COORDINATES = "CHAMBER_SET_CENTRALICED_COORDINATES";
export const CHAMBER_BED_MOVED = "CHAMBER_BED_MOVED";
export const CHAMBER_BED_CONTEXT_SELECTED = "CHAMBER_BED_CONTEXT_SELECTED";
export const CHAMBER_BED_TRANSFORMED = "CHAMBER_BED_TRANSFORMED";
export const CHAMBER_BED_CHAMBER_ROWS_REBUILD = "CHAMBER_BED_CHAMBER_ROWS_REBUILD";
export const CHAMBER_BED_CLEAN = "CHAMBER_BED_CLEAN";

export const BULKADDREMOVETOOL_EDIT = "BULKADDREMOVETOOL_EDIT";
export const BULKADDREMOVETOOL_START_DRAGGING = "BULKADDREMOVETOOL_START_DRAGGING";
export const BULKADDREMOVETOOL_UPDATE_DEIMENSIONS = "BULKADDREMOVETOOL_UPDATE_DIMENSIONS";
export const BULKADDREMOVETOOL_END_DRAGGING = "BULKADDREMOVETOOL_END_DRAGGING";
export const BULKADDREMOVETOOL_SET_PIXELS = "BULKADDREMOVETOOL_SET_PIXELS";
export const BULKADDREMOVETOOL_RESET = "BULKADDREMOVETOOL_RESET";

/* SYSTEM */
export const SYSTEM_START_GENERATION = "SYSTEM_START_GENERATION";
export const SYSTEM_END_GENERATION = "SYSTEM_END_GENERATION";
export const CLEAN_END_GENERATION = "CLEAN_END_GENERATION";


export const VOLUME_START_OPTIMIZER = "VOLUME_START_OPTIMIZER";
export const VOLUME_END_OPTIMIZER = "VOLUME_END_OPTIMIZER";

export const CHAMBER_ROW_CONTEXT_SELECTED = "CHAMBER_ROW_CONTEXT_SELECTED";
export const MANIFOLD_SET_ISOLATOR_STATUS = "MANIFOLD_SET_ISOLATOR_STATUS";
export const CHAMBER_ROW_SET_OFFSET = "CHAMBER_ROW_SET_OFFSET";

export const CHAMBER_ACTIVATE = "CHAMBER_ACTIVATE";
export const CHAMBERS_ACTIVATE = "CHAMBERS_ACTIVATE";
export const CHAMBER_DEACTIVATE = "CHAMBER_DEACTIVATE";
export const CHAMBERS_DEACTIVATE = "CHAMBERS_DEACTIVATE";
export const CHAMBER_ADD_LEFT = "CHAMBER_ADD_LEFT";
export const CHAMBER_ADD_TOP = "CHAMBER_ADD_TOP";
export const CHAMBER_ADD_RIGHT = "CHAMBER_ADD_RIGHT";
export const CHAMBER_ADD_DOWN = "CHAMBER_ADD_DOWN";
export const CHAMBER_ADD_ROW = "CHAMBER_ADD_ROW";
export const CHAMBER_REMOVE_LEFT = "CHAMBER_REMOVE_LEFT";
export const CHAMBER_REMOVE_TOP = "CHAMBER_REMOVE_TOP";
export const CHAMBER_REMOVE_RIGHT = "CHAMBER_REMOVE_RIGHT";
export const CHAMBER_REMOVE_DOWN = "CHAMBER_REMOVE_DOWN";
export const CHAMBER_REMOVE_ROW = "CHAMBER_REMOVE_ROW";
export const CHAMBER_SET_SELECTED = "CHAMBER_SET_SELECTED";
export const CHAMBER_CONTEXT_SELECTED = "CHAMBER_CONTEXT_SELECTED";
export const CHAMBER_RESET_SELECTED = "CHAMBER_RESET_SELECTED";
export const CHAMBER_SET_ACCESORY = "CHAMBER_SET_ACCESORY";
export const CHAMBER_SET_UPPER_CAP_ACCESORY = "CHAMBER_SET_UPPER_CAP_ACCESORY";
export const CHAMBER_SET_LOWER_CAP_ACCESORY = "CHAMBER_SET_LOWER_CAP_ACCESORY";
export const CHAMBERS_META_UPDATE = "CHAMBERS_META_UPDATE";
export const CHAMBERS_META_CLEAN = "CHAMBERS_META_CLEAN";
export const CHAMBERS_MANIFOLD_META_UPDATE = "CHAMBERS_MANIFOLD_META_UPDATE";
export const CHAMBERS_ISOLATOR_UPDATE = "CHAMBERS_ISOLATOR_UPDATE";
export const CHAMBERS_MANIFOLD_VOID_CLEAN = "CHAMBERS_MANIFOLD_VOID_CLEAN";
export const CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN = "CHAMBERS_MANIFOLD_MAIN_ROW_CLEAN";
export const CHAMBERS_ISOLATOR_CLEAN = "CHAMBERS_ISOLATOR_CLEAN";
export const CHAMBER_SET_KEY_VALUE = "CHAMBER_SET_KEY_VALUE";


export const PIPE_RESET_ACCESSORIES = "PIPE_RESET_ACCESSORIES";
export const PIPE_SET_ACCESORY = "PIPE_SET_ACCESORY";
export const PIPE_REMOVE_ACCESORY = "PIPE_REMOVE_ACCESORY";

export const ENDCAP_ATTACH_ACCESSORY = "ENDCAP_ATTACH_ACCESSORY";
export const ENDCAP_CONTEXT_SELECTED = "ENDCAP_CONTEXT_SELECTED";
export const ENDCAP_POSITION_UPPER = "ENDCAP_POSITION_UPPER";
export const ENDCAP_POSITION_LOWER = "ENDCAP_POSITION_LOWER";

export const ADD_REMOVE_TOOL_MOVED = "ADD_REMOVE_TOOL_MOVED";

export const FLOATING_TOOL_MOVED = "FLOATING_TOOL_MOVED";
export const FLOATING_TOOL_PIPES_MOVED = "FLOATING_TOOL_PIPES_MOVED";


export const FLOATING_TOOL_TEE_MOVED = "FLOATING_TOOL_TEE_MOVED";
export const FLOATING_TOOL_TEE_OPEN = "FLOATING_TOOL_TEE_OPEN";
export const FLOATING_TOOL_TEE_CLOSE = "FLOATING_TOOL_TEE_CLOSE";
export const FLOATING_TOOL_INSPECTION_MOVED = "FLOATING_TOOL_INSPECTION_MOVED";
export const FLOATING_TOOL_INSPECTION_OPEN = "FLOATING_TOOL_INSPECTION_OPEN";
export const FLOATING_TOOL_INSPECTION_CLOSE = "FLOATING_TOOL_INSPECTION_CLOSE";

export const DEBUGING_TOOL_MOVED = "DEBUGING_TOOL_MOVED";

export const CONTEXT_SELECTED_ELEMENT_TYPE_ENDCAP = "CONTEXT_SELECTED_ELEMENT_TYPE_ENDCAP";
export const CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER = "CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER";
export const CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW = "CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW";
export const CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED = "CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED";

export const CONTEXT_ELEMENT_DESELECT = "CONTEXT_ELEMENT_DESELECT";
export const CONTEXT_ELEMENT_PIPES_DESELECT = "CONTEXT_ELEMENT_PIPES_DESELECT";

export const CONTEXT_SELECTED_PIPE_ELEMENT = "CONTEXT_SELECTED_PIPE_ELEMENT";
export const CONTEXT_DESELECTED_PIPE_ELEMENT = "CONTEXT_DESELECTED_PIPE_ELEMENT";

export const PIPE_ELEMENT_TYPE_BEND = "PIPE_ELEMENT_TYPE_BEND";
export const PIPE_ELEMENT_TYPE_STICK = "PIPE_ELEMENT_TYPE_STICK";
export const PIPE_ELEMENT_TYPE_SINGLE_TEE = "PIPE_ELEMENT_TYPE_SINGLE_TEE";
export const PIPE_ELEMENT_TYPE_DOUBLE_TEE = "PIPE_ELEMENT_TYPE_DOUBLE_TEE";
export const PIPE_ELEMENT_TYPE_TRIPLE_TEE = "PIPE_ELEMENT_TYPE_TRIPLE_TEE";

export const PIPE_POSITION_LEFT = "left";
export const PIPE_POSITION_CENTER = "center";
export const PIPE_POSITION_RIGHT = "right";
export const PIPE_SIDE_TOP = "top";
export const PIPE_SIDE_SIDE = "side";
export const PIPE_SIDE_RIGHT = "right";
export const PIPE_SIDE_LEFT = "left";

export const CALCULATIONS_CALL_API_SUCCESS = "CALCULATIONS_CALL_API_SUCCESS";
export const CALCULATIONS_CALL_API_FAILURE = "CALCULATIONS_CALL_API_FAILURE";
export const CALCULATIONS_SET_MANIFOLD_SIZING = "CALCULATIONS_SET_MANIFOLD_SIZING";
export const CALCULATIONS_SET_PARAMETER_VALUE = "CALCULATIONS_SET_PARAMETER_VALUE";
export const CALCULATIONS_SWITCH_POROUS_STORAGE = "CALCULATIONS_SWITCH_POROUS_STORAGE";
export const CALCULATIONS_SWITCH_UNDERDRAIN = "CALCULATIONS_SWITCH_UNDERDRAIN";
export const CALCULATIONS_VOLUME_OPTIMIZED = "CALCULATIONS_VOLUME_OPTIMIZED";
export const CALCULATIONS_SET_MANIFOLD_SEPARATIONS = "CALCULATIONS_SET_MANIFOLD_SEPARATIONS";
export const SHOW_GENERATE_ALERT = "SHOW_GENERATE_ALERT";

export const PIPE_GLOBALS_SET_SCALE_PIXELS = "PIPE_GLOBALS_SET_SCALE_PIXELS";
export const PIPE_GLOBALS_SET_SCALE_VALUE = "PIPE_GLOBALS_SET_SCALE_VALUE";
export const PIPE_CALCULATIONS_SET_PARAMETER_VALUE = "PIPE_CALCULATIONS_SET_PARAMETER_VALUE";

/* MESSAGES */
export const MSG_INVALID_DRAWING_MODE_ERROR = "Not valid drawing mode.";
export const MSG_INVALID_CONTEXT_ELEMENT_TYPE_ERROR = "Not valid context element type.";

/* THE MISC TYPES */
export const OUTLET_MANIFOLD_ID = "Outlet-Manifold";
export const INLET_MANIFOLD_ID = "Inlet-Manifold";

/* MANIFOLDS */
export const MANIFOLD_RENDER_UPPER = "MANIFOLD_RENDER_UPPER";
export const MANIFOLD_RENDER_LOWER = "MANIFOLD_RENDER_LOWER";
export const MANIFOLD_RENDER_MAIN = "MANIFOLD_RENDER_MAIN";
export const ADD_NEW_MANIFOLD_MAIN = "ADD_NEW_MANIFOLD_MAIN";
export const REMOVE_MANIFOLD_MAIN = "REMOVE_MANIFOLD_MAIN";
export const CHANGE_MANIFOLD_PROP_MAIN = "CHANGE_MANIFOLD_PROP_MAIN";
export const CLEAR_MANIFOLD_MAIN = "CLEAR_MANIFOLD_MAIN";
export const REMOVE_BY_IDS_MANIFOLD_MAIN = "REMOVE_BY_IDS_MANIFOLD_MAIN";

/* AUTHENTICATION */
export const AUTHENTICATION_SWITCH_SIGNIN_PROCESS = "AUTHENTICATION_SWITCH_SIGNIN_PROCESS";
export const AUTHENTICATION_USER_SIGNIN = "AUTHENTICATION_USER_SIGNIN";
export const AUTHENTICATION_USER_SIGNOUT = "AUTHENTICATION_USER_SIGNOUT";
export const AUTHENTICATION_USER_UPDATEDATA = "AUTHENTICATION_USER_UPDATEDATA";

/* PDF */
export const PDF_TOGGLE_MODAL = "PDF_TOGGLE_MODAL";
export const PIPES_PDF_TOGGLE_MODAL = "PIPES_PDF_TOGGLE_MODAL";
export const PDF_PAGE_SIZES = "PDF_PAGE_SIZES";
export const IMG_PAGE_SIZES = "IMG_PAGE_SIZES";
export const PDF_PAGE_UNIT = "PDF_PAGE_UNIT";

/* PROJECTS CRUD */
export const PROJECTS_CRUD_MODAL = "PROJECTS_CRUD_MODAL";
export const PROJECTS_CRUD_SET_LIST = "PROJECTS_CRUD_SET_LIST";
export const PROJECTS_CRUD_RESET = "RESET_PROJECTS_CRUD";
export const PROJECTS_CRUD_SET_CURRENT_PROJECT = "PROJECTS_CRUD_SET_CURRENT_PROJECT";
export const ATTEMPT_TO_SAVE_CURRENT_PROJECT = "ATTEMPT_TO_SAVE_CURRENT_PROJECT";
export const PROJECTS_CRUD_SET_INFORMATION = "PROJECTS_CRUD_SET_INFORMATION";
export const PROJECTS_CRUD_RESTORE_STATE = "PROJECTS_CRUD_RESTORE_STATE";
export const NEW_BACKGROUND_REQUESTED = "NEW_BACKGROUND_REQUESTED";
export const SHOW_BACKGROUND_MULTIBED_WARNING = "SHOW_BACKGROUND_MULTIBED_WARNING";
export const SHOW_BACKGROUND_MOVED_TRANSFORMED = "SHOW_BACKGROUND_MOVED_TRANSFORMED";


/* SUB PROJECTS */
export const SUB_PROJECT_SET_STATUS = "SUB_PROJECT_SET_STATUS";

export const PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT = "PROJECTS_CRUD_SET_CURRENT_SUB_PROJECT";
// export const SUB_ATTEMPT_TO_SAVE_CURRENT_PROJECT = "SUB_ATTEMPT_TO_SAVE_CURRENT_PROJECT";
// export const SUB_PROJECTS_CRUD_SET_INFORMATION = "SUB_PROJECTS_CRUD_SET_INFORMATION";
export const SUB_PROJECTS_CRUD_RESTORE_STATE = "SUB_PROJECTS_CRUD_RESTORE_STATE";
export const SUB_APPTOOLBAR_RESET_APP_STATE = "SUB_APPTOOLBAR_RESET_APP_STATE";

/* PROJECTS ADMIN CRUD */
export const PROJECTS_ADMIN_CRUD_MODAL = "PROJECTS_ADMIN_CRUD_MODAL";
export const PROJECTS_ADMIN_MULTIBED_WARNING = "PROJECTS_ADMIN_MULTIBED_WARNING";
export const PROJECTS_ADMIN_SET_USER_LIST = "PROJECTS_ADMIN_SET_USER_LIST";
export const PROJECTS_ADMIN_SET_PROJECTS_LIST = "PROJECTS_ADMIN_SET_PROJECTS_LIST";
export const PROJECTS_ADMIN_SELECTED_USER = "PROJECTS_ADMIN_SELECTED_USER";
export const PROJECTS_ADMIN_IS_LOADING = "PROJECTS_ADMIN_IS_LOADING";
export const PROJECTS_ADMIN_LOADED_OTHER_U_PROJECT = "PROJECTS_ADMIN_LOADED_OTHER_U_PROJECT";

/* PROJECTS */
export const PROJECT_SET_STATUS = "PROJECT_SET_STATUS";

/* CHAMBER ACCESSORY IDS */
export const CHAMBER_ACCESSORY_ID_INSERTA_TEE = "Inserta-tee";
export const CHAMBER_ACCESSORY_ID_INSPECTION_PORT = "Inspection-port";
export const CHAMBER_ACCESSORY_ID_FEED_CONNECTOR = "Feed-connector";

// Pipe components
export const PIPE_STUB = "PIPE_STUB";
export const PIPE_RISER = "PIPE_RISER";
export const PIPE_CLEANOUT = "PIPE_CLEANOUT";
export const PIPE_INSERTA_TEE = "PIPE_INSERTA_TEE";

// Tutorial actions
export const TOGGLE_TUTORIAL = "TOGGLE_TUTORIAL";
export const TOGGLE_TUTORIAL_START_DIALOG = 'TOGGLE_TUTORIAL_START_DIALOG';
export const TOGGLE_TUTORIAL_CONFIRMATION_DIALOG = 'TOGGLE_TUTORIAL_CONFIRMATION_DIALOG';
export const SET_CURRENT_TUTORIAL_STEP = 'SET_CURRENT_TUTORIAL_STEP';

// Accordion actions
export const OPEN_ACCORDION_SECTION = 'OPEN_ACCORDION_SECTION';
export const CLOSE_ACCORDION_SECTION = 'CLOSE_ACCORDION_SECTION';
export const EXPAND_ACCORDION = 'EXPAND_ACCORDION';
export const CLOSE_ACCORDION = 'CLOSE_ACCORDION';

// Modal alert
export const MODAL_ALERT = "MODAL_ALERT";
export const MODAL_ALERT_TEXT = "MODAL_ALERT_TEXT";

// Change product type
export const SWITCH_PRODUCT_TYPE = "SWITCH_PRODUCT_TYPE";

/* CONSTRAINTS */
export const CONSTRAINTS_SET_DEFAULTS = "CONSTRAINTS_SET_DEFAULTS";
export const CONSTRAINTS_SET_MINIMUMS = "CONSTRAINTS_SET_MINIMUMS";
export const CONSTRAINTS_SET_MAXIMUMS = "CONSTRAINTS_SET_MAXIMUMS";
export const PIPE_CONSTRAINTS_SET_DEFAULTS = "PIPE_CONSTRAINTS_SET_DEFAULTS";
export const PIPE_CONSTRAINTS_SET_MINIMUMS = "PIPE_CONSTRAINTS_SET_MINIMUMS";
export const PIPE_CONSTRAINTS_SET_MAXIMUMS = "PIPE_CONSTRAINTS_SET_MAXIMUMS";

export const PIPE_ACCESSORY_RISER = "PIPE_ACCESSORY_RISER";
export const PIPE_ACCESSORY_STUB_INVERT_MATCHING = "PIPE_ACCESSORY_STUB_INVERT_MATCHING";
export const PIPE_ACCESSORY_STUB_CONCENTRIC = "PIPE_ACCESSORY_STUB_CONCENTRIC";
export const PIPE_ACCESSORY_STUB_CROWN_MATCHING = "PIPE_ACCESSORY_STUB_CROWN_MATCHING";
export const PIPE_ACCESSORY_CLEANOUT_LEFT = "PIPE_ACCESSORY_CLEANOUT_LEFT";
export const PIPE_ACCESSORY_CLEANOUT = "PIPE_ACCESSORY_CLEANOUT";
export const PIPE_ACCESSORY_CLEANOUT_RIGHT = "PIPE_ACCESSORY_CLEANOUT_RIGHT";
export const PIPE_ACCESSORY_INSERTA_TEE = "PIPE_ACCESSORY_INSERTA_TEE";
export const PIPE_ACCESSORY_ROUND_BASIN = "PIPE_ACCESSORY_ROUND_BASIN";
export const PIPE_ACCESSORY_SQUARE_BASIN = "PIPE_ACCESSORY_SQUARE_BASIN";

export const PIPE_TYPE_SOIL_TIGHT_ID = "Soil Tight";
export const PIPE_TYPE_SOIL_TIGHT_NAME = "Soil Tight";
export const PIPE_TYPE_SOIL_TIGHT_PERFORATED_ID = "Soil Tight Perforated";
export const PIPE_TYPE_SOIL_TIGHT_PERFORATED_NAME = "Soil Tight Perforated";
export const PIPE_TYPE_WATER_TIGHT_ID = "Water Tight";
export const PIPE_TYPE_WATER_TIGHT_NAME = "Water Tight";
export const PIPE_PART_MANIFOLD_T = "Manifold-T";
export const PIPE_PART_CORNER = "Corner";
export const HDPE_N12_ID = "HDPE N-12";
export const PIPE_DETENTION_SYSTEM_ID = "Detention-System";
export const PIPE_DETENTION_SYSTEM_NAME = "Detention system";
export const PIPE_CUSTOMF_FITTING_ID = "Custom-Fitting";
export const PIPE_CUSTOMF_FITTING_NAME = "Custom fitting";
export const PIPE_LINE_LAYOUT_ID = "Line-Layout";
export const PIPE_LINE_LAYOUT_NAME = "Line layout";
export const PIPE_RETENTION_SYSTEM_ID = "Retention-System";
export const PIPE_RETENTION_SYSTEM_NAME = "Retention system";
export const PIPE_SWITCH_THERMOPLASTIC_LINTER = "PIPE_SWITCH_THERMOPLASTIC_LINTER";

/* PIPE COMPONENT */
export const PIPE_SET_PITCH = "PIPE_SET_PITCH";
export const PIPE_SET_MANIFOLD_T = "PIPE_SET_MANIFOLD_T";
export const PIPE_SET_MANIFOLD_CORNER = "PIPE_SET_MANIFOLD_CORNER";
export const PIPE_SET_BED_POSITION = "PIPE_SET_BED_POSITION";
export const PIPE_SET_BED_TRANSFORMATION = "PIPE_SET_BED_TRANSFORMATION";
export const PIPE_SET_BED_CENTRALICED_COORDINATES =
  "PIPE_SET_BED_CENTRALICED_COORDINATES";

/* Pipe accessories */
export const SET_PIPE_RISER = "SET_PIPE_RISER";
export const SET_PIPE_INVERT = "SET_PIPE_INVERT";
export const SET_PIPE_CLEANOUT = "SET_PIPE_CLEANOUT";
export const SET_PIPE_INSERTA_TEE = "SET_PIPE_INSERTA_TEE";
export const PIPE_SET_BED_DIMENSIONS = "PIPE_SET_BED_DIMENSIONS";
export const PIPE_EDIT_ACCESSORY_STACK = "PIPE_EDIT_ACCESSORY_STACK";
export const PIPE_BED_UPPER_MANIFOLD = "PIPE_BED_UPPER_MANIFOLD";
export const PIPE_BED_LOWER_MANIFOLD = "PIPE_BED_LOWER_MANIFOLD";
export const PIPE_BED_PIPE_ROWS = "PIPE_BED_PIPE_ROWS";
export const PIPE_MANIFOLD_TEE_TYPE = {
  SINGLE: 1,
  DOUBLE: 2,
  TRIPLE: 3
};
export const PIPE_FLOW_ARROW_ORIENTATION = {
  UP: "UP",
  DOWN: "DOWN",
  LEFT: "LEFT",
  RIGHT: "RIGHT"
};
export const PIPE_FLOW_BASIN_POSITION = {
  TOP_LEFT: "TOP_LEFT",
  TOP_RIGHT: "TOP_RIGHT",
  BOTTOM_LEFT: "BOTTOM_LEFT",
  BOTTOM_RIGHT: "BOTTOM_RIGHT"
};
export const PIPE_FLOW_BASIN_SHAPE_TYPE = {
  ROUND: "round",
  SQUARE: "square",
  NONE: null
};
export const PIPE_SET_FLOW_OUTLET_POSITION = "PIPE_SET_FLOW_OUTLET_POSITION";
export const PIPE_SET_FLOW_INLET_POSITION = "PIPE_SET_FLOW_INLET_POSITION";
export const PIPE_SET_FLOW_OUTLET_SHAPE_TYPE = "PIPE_SET_FLOW_OUTLET_SHAPE_TYPE";
export const PIPE_SET_FLOW_INLET_SHAPE_TYPE = "PIPE_SET_FLOW_INLET_SHAPE_TYPE";
export const PIPE_RESET_SHAPE_TYPE = "PIPE_RESET_SHAPE_TYPE";

/* LOCALIZATION */
export const LOCALIZATION_SET_ACTIVE_REGION = "LOCALIZATION_SET_ACTIVE_REGION";
export const LOCALIZATION_SET_SYSTEM_UNIT = "LOCALIZATION_SET_SYSTEM_UNIT";
export const LOCALIZATION_SET_ACTIVE_LANGUAGE = "LOCALIZATION_SET_ACTIVE_LENGUAGE";
export const LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE = "LOCALIZATION_SET_USERS_REGION_AND_LANGUAGE";
export const LOCALIZATION_SET_USER_DEFAULTS = "LOCALIZATION_SET_USER_DEFAULTS";

export const LEGACY_COMPONENT_USER_DIALOG = "LEGACY_COMPONENT_USER_DIALOG";

/* Tracking state being restored from Manage Projects */
export const RESTORED_STATE_BED_RENDERED = "RESTORED_STATE_BED_RENDERED";

/* Chamber Type ID's */
export const CHAMBER_TYPE_ID_MC7200 = "MC-7200";
export const CHAMBER_TYPE_ID_MC4500 = "MC-4500";
export const CHAMBER_TYPE_ID_MC3500 = "MC-3500";
export const CHAMBER_TYPE_ID_SC740 = "SC-740";
export const CHAMBER_TYPE_ID_SC310 = "SC-310";
export const CHAMBER_TYPE_ID_SC160LP = "SC-160LP";
export const CHAMBER_TYPE_ID_DC780 = "DC-780";
export const CHAMBER_TYPE_ID_C100HD = "C-100HD";

/* Manifold Entry Dialog */
export const MANIFOLD_ENTRY_MOVED = "MANIFOLD_ENTRY_MOVED";
export const SET_SELECTED_MANIFOLD = "SET_SELECTED_MANIFOLD";
export const SHOW_MANIFOLD_ENTRY = "SHOW_MANIFOLD_ENTRY";
export const CLOSE_MANIFOLD_ENTRY = "CLOSE_MANIFOLD_ENTRY";
export const MANIFOLD_ENTRY_CHECK_FOR_OVERLAP = "MANIFOLD_ENTRY_CHECK_FOR_OVERLAP";
export const MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG = "MANIFOLD_ENTRY_SHOW_OVERLAP_DIALOG";
export const MANIFOLD_ENTRY_REMOVE_OVERLAPPING = "MANIFOLD_ENTRY_REMOVE_OVERLAPPING";
export const SET_CURRENT_MANIFOLD_ENTRY = "SET_CURRENT_MANIFOLD_ENTRY";
export const CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG = "CLOSE_MANIFOLD_REMOVAL_PROMPT_DIALOG";
export const SET_OVERLAP_PRESENT = "SET_OVERLAP_PRESENT";
export const SET_STRUCTURE_COLLISION_PRESENT = "SET_STRUCTURE_COLLISION_PRESENT";
export const SET_OP_STRUCTURE_COLLISION_PRESENT = "SET_OP_STRUCTURE_COLLISION_PRESENT";
export const MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT = "MANIFOLD_ENTRY_MANIFOLD_CHAMBER_SHOW_EDIT_OR_REMOVE_PROMPT";

/* System Parameters and Advanced Settings  */
export const SAVE_SYS_PARAMETERS_STATE = "SAVE_SYS_PARAMETERS_STATE";
export const RESET_SYS_PARAMETERS_STATE = "RESET_SYS_PARAMETERS_STATE";

/* Current chamber  */
export const CURRENT_CHAMBER_UPDATE = "CURRENT_CHAMBER_UPDATE";

/* MC-4500 Deprecation */
export const HIDE_MC4500_DEPRECATION_ALERT = "HIDE_MC4500_DEPRECATION_ALERT";

/* Dialog for invalid projects URLS */
export const SET_PROJECT_URL_INVALID = "SET_PROJECT_URL_INVALID";

/* Multi-Bed */
export const CONVERT_TO_MULTIBED_PROJECT = "CONVERT_TO_MULTIBED_PROJECT";
export const SET_SELECTED_BED = "SET_SELECTED_BED";
export const UPDATE_SELECTED_BED = "UPDATE_SELECTED_BED";
export const UPDATE_BEDS_PAYLOAD = "UPDATE_BEDS_PAYLOAD";
export const ADD_NEW_BED = "ADD_NEW_BED";
export const UPDATE_PLACEHOLDER = "UPDATE_PLACEHOLDER";
export const DELETE_PLACEHOLDER = "DELETE_PLACEHOLDER";
export const RENAME_BED = "RENAME_BED";
export const DELETE_BED = "DELETE_BED";
export const DELETE_TEMP_BED = "DELETE_TEMP_BED";
export const SHOW_UNSAVED_CHANGES_DIALOG = "SHOW_UNSAVED_CHANGES_DIALOG";
export const HIDE_UNSAVED_CHANGES_DIALOG = "HIDE_UNSAVED_CHANGES_DIALOG";
export const UPDATE_MULTIBED_SAVE_AS = "UPDATE_MULTIBED_SAVE_AS";
export const UPDATE_BED_SAVE_AS = "UPDATE_BED_SAVE_AS";
export const SET_SELECTED_TAB_KEY = "SET_SELECTED_TAB_KEY";
export const LOADING_BED = "LOADING_BED";
export const LOADING_MULTIBED_PROJECT = "LOADING_MULTIBED_PROJECT";
export const IS_DIRTY = "IS_DIRTY";
export const HIDE_VOLUMES_COMPONENT = "HIDE_VOLUMES_COMPONENT";
export const SET_MULTI_BED_OTHER_USER_DATA = "SET_MULTI_BED_OTHER_USER_DATA";
export const SET_MULTI_BED_DESKTOP_ENABLED = "SET_MULTI_BED_DESKTOP_ENABLED";
export const SET_UPDATE_PERIMETER = "SET_UPDATE_PERIMETER";
export const UPDATE_MULTIBED_SCALE = "UPDATE_MULTIBED_SCALE";
export const SHOW_MULTIBED_SCALE_DIALOG = "SHOW_MULTIBED_SCALE_DIALOG";

export const SET_DISABLED_LAYER_DIALOG = "SET_DISABLED_LAYER_DIALOG";

export const SET_OVERALL_TOTAL = "SET_OVERALL_TOTAL";

// FORMS
export const FORM_ASSEMBLY_TOGGLE_MODAL = "FORM_ASSEMBLY_TOGGLE_MODAL";
export const SIGN_UP_MODAL_TOGGLE = "SIGN_UP_MODAL_TOGGLE";
export const REP_CONTACT_TOGGLE_DIALOG = "REP_CONTACT_TOGGLE_DIALOG";
export const SALES_CONTACT_DIALOG = "SALES_CONTACT_DIALOG";
export const SYSTEM_NOTES_TOGGLE_DIALOG = "SYSTEM_NOTES_TOGGLE_DIALOG";



// WEBPACK FOOTER //
// ./src/lib/types.js